import cn from 'classnames';
import React, { Component } from 'react';
import queryString from 'query-string';
import {
  Table,
  Input,
  message,
  Modal,
  Alert,
  Button,
  Icon,
  Progress,
  Popconfirm,
  TreeSelect,
  Select,
} from 'antd';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import columns, { statusMap } from './columns';
import { backendErrorTip } from '../../../../utils';
import xfetch from '../../../../xfetch';
import AddToRelatedQuestion from './AddToRelatedQuestion';
import AddQuestionForm from '../Question/UpdateForm';
import s from './style.css';

const { Search } = Input;
const { Option } = Select;
const { TreeNode } = TreeSelect;

@withStyles(s)
export default class Learn extends Component {
  constructor(props) {
    super(props);
    this.q = {
      page_size: 10,
      page: 1,
    };
    this.baseApi = `${window.G.backendApi}/knowledge/unknown_question/`;
    this.trainAPi = `${window.G.backendApi}/knowledge/answer/train/`;
    this.orgTreeApi = `${window.G.backendApi}/profiles/organization/tree/`;
    this.baseAnswerApi = `${window.G.backendApi}/knowledge/answer/`;
    this.baseQsApi = `${window.G.backendApi}/knowledge/question/`;
  }
  state = {
    data: {},
    item: {},
    loading: true,
    knowledges: [],
    knowledgeCategories: [],
    modals: {
      addQuestionModal: { title: '', visible: false },
      learnProgressModal: { title: '', visible: false },
      relatedQS: { title: '', visible: false },
    },
    newQuestion: {},
    matchAnswer: {},
    updateItemLoading: false,
    autoCompleteLoading: false,
    autoCompleteQuestions: [],
    acValue: '',
    trainStatus: 'doing',
    settings: {},
    learnTotalTime: '',
    treeNodes: [],
  };
  componentDidMount() {
    this.query();
    this.queryFilters();
    this.getSettings();
    this.getTrainStatus();
    this.queryOrgTree();
  }
  onTableChange = pagination => {
    const { current } = pagination;
    this.q.page = current;
    this.query();
  };
  setModals = async ({ key, title, item = {}, visible }) =>
    new Promise(resolve => {
      this.setState(
        {
          modals: {
            ...this.state.modals,
            [key]: {
              ...this.state.modals[key],
              title,
              visible,
            },
          },
          item,
        },
        resolve,
      );
    });

  getSettings = async () => {
    const { error, result } = await xfetch(
      `${window.G.backendApi}/system/settings/`,
    );
    if (error) {
      return;
    }
    this.setState({
      settings: result.length ? result[0] : {},
    });
  };
  setMatchAnswer = matchAnswer => this.setState({ matchAnswer });
  setACValue = acValue => this.setState({ acValue });
  getTrainStatus = async () => {
    const { result: trainStatus = {} } = await xfetch(this.trainAPi);
    return new Promise(resolve => {
      this.setState(
        {
          trainStatus: trainStatus.status,
        },
        () => resolve(trainStatus.status),
      );
    });
  };
  query = async () => {
    const api = `${this.baseApi}?${queryString.stringify(this.q)}`;
    const { error, result } = await xfetch(api);
    this.setState({
      loading: false,
    });
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.setState({
      data: result,
    });
  };

  queryFilters = async () => {
    const knowledgeApi = `${window.G.backendApi}/knowledge/knowledge/options/?status=on`;
    const knowledgeCategoryApi = `${window.G.backendApi}/knowledge/knowledge_category/options/?status=on`;
    const { result: knowledges } = await xfetch(knowledgeApi);
    const { result: knowledgeCategories } = await xfetch(knowledgeCategoryApi);
    this.setState({
      knowledges,
      knowledgeCategories,
    });
  };
  queryOrgTree = async () => {
    const { error, result } = await xfetch(this.orgTreeApi);
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.setState({
      treeNodes: result.tree,
    });
  };
  handleSearch = search => {
    this.q.search = search;
    this.q.page = 1;
    this.query();
  };
  displayContext = item => {
    const { settings } = this.state;
    const { context, desc } = item;
    Modal.info({
      title: '会话记录',
      width: 700,
      maskClosable: true,
      content: (
        <div className={s.qaBox}>
          <div className={s.msgBox}>
            <div className={s.msgList}>
              <div className={s.qsBox}>
                <div className={s.ask}>
                  <img src="/assets/images/user.png" alt="" width="32" />
                  <div className={cn(s.askBox, s.msg)}>{desc}</div>
                </div>
                <div className={s.answer}>
                  <img src={settings.robot_avatar} alt="" width="32" />
                  <div className={cn(s.answerBox, s.msg)}>
                    {this.renderAnswers(context)}
                    {/* {context &&
                      context.map(qs => (
                        <div key={qs.question_id}>{qs.question_title}</div>
                      ))} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* {context.map(({ question_title: q, answer_content: a, id }) => (
            <div className={s.qaWrap}>
              <div key={`q_${id}`} className={s.qaItem}>
                <div className={s.qaType}>问：</div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: q,
                  }}
                />
              </div>
              <div key={`a_${id}`} className={s.qaItem}>
                <div className={s.qaType}>答：</div>
                <div
                  dangerouslySetInnerHTML={{
                    __html: a,
                  }}
                />
              </div>
            </div>
          ))} */}
        </div>
      ),
      onOk() {},
    });
  };
  handleChangeItem = item => this.setState({ item });
  addQuestion = (answer, title) =>
    xfetch(this.baseQsApi, {
      method: 'POST',
      body: {
        answer,
        title,
      },
    });
  handleAddQuestion = (addRelated = false) => {
    const { item } = this.state;
    this.setState({
      updateItemLoading: true,
    });
    this.updateForm.validateFields(async (err, values) => {
      if (err) {
        return;
      }
      const {
        questionTitle,
        knowledge,
        knowledge_category: knowledgeCategory,
        status,
        content,
        organization,
        content_type: contentType,
      } = values;

      if (!content) {
        backendErrorTip('答案不能为空');
        this.setState({
          updateItemLoading: false,
        });
        return;
      }
      // 先添加答案
      const { error, result } = await xfetch(this.baseAnswerApi, {
        body: {
          status: status ? 'on' : 'off',
          knowledge,
          organization,
          knowledge_category: knowledgeCategory,
          content,
          content_type: contentType,
        },
        method: 'POST',
      });
      if (error) {
        this.setState({
          updateItemLoading: false,
        });
        backendErrorTip(error);
        return;
      }
      // 2. 再添加答案的标准问法
      const { error: error2, result: newQuestion } = await this.addQuestion(
        result.id,
        questionTitle,
      );
      if (error2) {
        backendErrorTip(error2);
        this.setState({
          updateItemLoading: false,
        });
        return;
      }
      console.info(newQuestion);
      // 关联到未知问题逻辑
      if (addRelated) {
        // 自动补全问题搜索框
        this.setState(
          {
            updateItemLoading: false,
            newQuestion: {
              id: newQuestion.id,
            },
            matchAnswer: {
              id: newQuestion.id,
              title: newQuestion.title,
            },
            acValue: newQuestion.title,
          },
          async () => {
            await this.handleChangeUnknownQuestion('added');
          },
        );
        this.setModals({
          key: 'addQuestionModal',
          title: '添加问题',
          visible: false,
          item,
        });
        await this.handleQuestionACSearch(newQuestion.title);
        // 添加到知识库逻辑
      } else {
        this.setState(
          {
            newQuestion: {
              id: newQuestion.id,
            },
            matchAnswer: {
              id: newQuestion.id,
              title: newQuestion.title,
            },
          },
          async () => {
            await this.handleChangeUnknownQuestion('added');
          },
        );
      }
    });
  };
  handleQuestionACSearch = async v => {
    if (!v) {
      return;
    }
    const questionOptionApi = `${window.G.backendApi}/knowledge/question/options?search=${v}&page_size=100`;
    this.setState({
      autoCompleteLoading: true,
    });
    const { error, result } = await xfetch(questionOptionApi);
    this.setState({
      autoCompleteLoading: false,
    });
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.setState({
      autoCompleteQuestions: result.results,
    });
  };
  handleChangeUnknownQuestion = async status => {
    const { item, acValue, matchAnswer } = this.state;
    let { newQuestion } = this.state;
    // 如果没有新建问题，直接从问题下拉选择的，需要重新新建一个
    if (newQuestion.id === undefined) {
      // 添加一条 question
      if (!item.desc) {
        message.warn('所选问题描述不能为空');
        return;
      }
      const res = await this.addQuestion(matchAnswer.answer, item.desc);
      if (res.error) {
        backendErrorTip(res.error);
        this.setState({
          updateItemLoading: false,
        });
        return;
      }
      newQuestion = res.result;
    }
    const { error } = await xfetch(`${this.baseApi}${item.id}/`, {
      method: 'PATCH',
      body: {
        status,
        question: Number(matchAnswer.id),
      },
    });
    if (error) {
      this.setState({
        updateItemLoading: false,
      });
      backendErrorTip(error);
      return;
    }
    this.setState({
      updateItemLoading: false,
      acValue: status === 'added' ? acValue : '',
      newQuestion: {},
    });
    message.success(status === 'added' ? '已添加到知识库' : '已关联为现有问题');
    this.setModals({
      key: status === 'added' ? 'addQuestionModal' : 'relatedQS',
      title: '',
      visible: false,
      item,
    });
    this.query();
  };
  handleIgnore = async (id, ignored) => {
    const { error } = await xfetch(`${this.baseApi}${id}/`, {
      method: 'PATCH',
      body: {
        status: ignored ? 'todo' : 'ignored',
      },
    });
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.query();
    message.success('已忽略');
  };
  handleTrain = async () => {
    this.setState({
      trainStatus: 'doing',
    });
    const { modals } = this.state;
    const { error, result } = await xfetch(this.trainAPi, {
      method: 'POST',
    });
    if (error) {
      backendErrorTip(error);
      return;
    }
    this.setState(
      {
        learnProgress: 1,
        learnTotalTime: result.total_time,
        modals: {
          ...modals,
          learnProgressModal: {
            visible: true,
            title: '正在学习',
          },
        },
      },
      () => {
        this.timer = setInterval(async () => {
          const { learnProgress } = this.state;
          if (learnProgress < 100 && learnProgress > 90) {
            const status = await this.getTrainStatus();
            if (status === 'doing') {
              return;
            }
          }
          if (learnProgress > 100) {
            this.setState({
              trainStatus: 'idle',
            });
            message.success('学习完成');
            clearInterval(this.timer);
            this.setState({
              modals: {
                ...modals,
                learnProgressModal: {
                  visible: false,
                  title: '正在学习',
                },
              },
            });
            return;
          }
          this.setState({
            learnProgress: Math.ceil(learnProgress + 100 / result.total_time),
          });
        }, 1000);
      },
    );
  };
  renderAnswers = questions => [
    <div
      key="1"
      dangerouslySetInnerHTML={{ __html: questions[0].question_title }}
    />,
    <div key="2" className={s.likebox}>
      <span>
        <Icon type="like" />
        满意
      </span>
      <span>
        <Icon type="dislike" />
        不满意
      </span>
    </div>,
    <div key="3" className={cn(s.answerTip, s.relations)}>
      相关问题
    </div>,
    questions
      .slice(1)
      .map(x => (
        <div
          className={s.relativeQs}
          key={x.id}
          dangerouslySetInnerHTML={{ __html: x.question_title }}
        />
      )),
  ];
  renderTreeNodes = tree => {
    const data = Object.values(tree);
    return data.map(item => {
      if (item.children) {
        return (
          <TreeNode
            disabled={item.deprecated}
            key={item.id}
            value={item.id}
            title={item.name}
          >
            {this.renderTreeNodes(item.children)}
          </TreeNode>
        );
      }
      return (
        <TreeNode
          value={item.id}
          disabled={item.deprecated}
          title={item.name}
        />
      );
    });
  };
  render() {
    const {
      data: { results, count = 0 },
      loading,
      item,
      modals: { relatedQS, addQuestionModal, learnProgressModal },
      knowledges,
      knowledgeCategories,
      updateItemLoading,
      autoCompleteLoading,
      autoCompleteQuestions,
      acValue,
      trainStatus,
      learnProgress,
      learnTotalTime,
      treeNodes,
    } = this.state;
    const pagination = {
      pageSize: 10,
      total: count,
      showTotal: t => `共 ${t} 条`,
      current: this.q.page,
    };
    const orgTreeNodes = this.renderTreeNodes(treeNodes);
    return (
      <div className={s.wrap}>
        <Alert
          message="提示：添加到知识库、关联相似问题需要机器人重新学习后生效。"
          type="warning"
          closable
          style={{ marginBottom: 15 }}
        />
        <div className={s.toolbar}>
          <div className={s.toolbarLeft}>
            <span className={s.toolbarField}>
              <span className={s.toolbarLabel}>组织机构：</span>
              <TreeSelect
                showSearch
                style={{ width: 140 }}
                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                placeholder="请选择"
                allowClear
                onChange={organization => {
                  this.q.organization = organization;
                  this.q.page = 1;
                  this.query();
                }}
                treeDefaultExpandAll
              >
                {orgTreeNodes}
              </TreeSelect>
            </span>
            <span className={s.toolbarField}>
              <span className={s.toolbarLabel}>问题状态：</span>
              <Select
                showSearch
                dropdownMatchSelectWidth
                placeholder="请选择"
                style={{ width: 140 }}
                filterOption={(inputValue, option) =>
                  option.props.children.indexOf(inputValue) > -1
                }
                onChange={v => {
                  this.q.status = v;
                  this.q.page = 1;
                  this.query();
                }}
              >
                <Option value="">全部</Option>
                {Object.keys(statusMap).map(key => (
                  <Option key={key} value={key}>
                    {statusMap[key]}
                  </Option>
                ))}
              </Select>
            </span>
          </div>
          <div className={s.toolbarRight}>
            <Popconfirm
              title="学习时会占用较多服务器资源。确认重新学习？"
              okText="确认"
              cancelText="取消"
              onConfirm={this.handleTrain}
            >
              <Button
                disabled={trainStatus === 'doing'}
                type="danger"
                style={{ marginRight: 20 }}
              >
                重新学习
              </Button>
            </Popconfirm>
            <Search
              placeholder="输入问题 / 答案关键词搜索"
              onSearch={this.handleSearch}
              style={{ width: 260 }}
              enterButton="搜索"
            />
          </div>
        </div>
        <div className={s.table}>
          <Table
            loading={loading}
            dataSource={results}
            columns={columns(this, s)}
            pagination={pagination}
            onChange={this.onTableChange}
          />
        </div>
        <Modal
          title={relatedQS.title}
          visible={relatedQS.visible}
          width={550}
          destroyOnClose
          maskClosable={false}
          onOk={() => this.handleChangeUnknownQuestion('related')}
          onCancel={() =>
            this.setModals({
              key: 'relatedQS',
              title: '',
              visible: false,
            })
          }
          className={s.updateGroupForm}
        >
          <AddToRelatedQuestion
            item={item}
            acValue={acValue}
            setModals={x => this.setModals(x)}
            autoCompleteLoading={autoCompleteLoading}
            setMatchAnswer={x => this.setMatchAnswer(x)}
            setACValue={this.setACValue}
            autoCompleteQuestions={autoCompleteQuestions}
            handleQuestionACSearch={this.handleQuestionACSearch}
          />
        </Modal>
        <Modal
          title={addQuestionModal.title}
          visible={addQuestionModal.visible}
          width={650}
          destroyOnClose
          maskClosable={false}
          confirmLoading={updateItemLoading}
          onOk={() => this.handleAddQuestion(item.addRelated)}
          onCancel={() =>
            this.setModals({
              key: 'addQuestionModal',
              title: '',
              visible: false,
            })
          }
          className={s.updateGroupForm}
        >
          <AddQuestionForm
            ref={x => {
              this.updateForm = x;
            }}
            changeItem={this.handleChangeItem}
            knowledges={knowledges}
            knowledgeCategories={knowledgeCategories}
            orgTreeNodes={orgTreeNodes}
            item={{
              ...item,
              questions: [{ title: item.desc }],
            }}
          />
        </Modal>
        <Modal
          title="正在学习..."
          destroyOnClose
          maskClosable={false}
          footer={null}
          width={400}
          visible={learnProgressModal.visible}
          onCancel={() =>
            this.setModals({
              key: 'learnProgressModal',
              title: '',
              visible: false,
            })
          }
        >
          <div>
            <div className={s.learnProgressTitle}>
              本次学习预计需要 {learnTotalTime} 秒，请稍后...
            </div>
            <Progress percent={learnProgress} status="active" />
          </div>
        </Modal>
      </div>
    );
  }
}
